import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'relatedActionsVertical',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-related-actions-vertical wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M12 3c1.105 0 2 .888 2 2 0 1.105-.888 2-2 2-1.105 0-2-.888-2-2 0-1.105.888-2 2-2Zm0 7c1.105 0 2 .888 2 2 0 1.105-.888 2-2 2-1.105 0-2-.888-2-2 0-1.105.888-2 2-2Zm0 7c1.105 0 2 .888 2 2 0 1.105-.888 2-2 2-1.105 0-2-.888-2-2 0-1.105.888-2 2-2Z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-related-actions-vertical.svg',
    category: 'Core',
    tags: ['three', 'dots', 'twinkie', 'more', 'kebob', 'menu', 'dropdown', 'select', 'meatballs', 'vertical', 'android'],
};
export default icon;
